module.exports = __webpack_public_path__ + "static/img/starroad.eaeee6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/services/starroad.png
// module id = jyl6
// module chunks = 1